// Generated by purs version 0.15.0
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Restaumatic_Menu_Query from "../Restaumatic.Menu.Query/index.js";
import * as Restaumatic_Menu_V2_MenuCatalogue from "../Restaumatic.Menu.V2.MenuCatalogue/index.js";
import * as Restaumatic_Menu_V2_Types_Ids_EntityId from "../Restaumatic.Menu.V2.Types.Ids.EntityId/index.js";
var askMenuCatalogue = /* #__PURE__ */ Data_Functor.map(Restaumatic_Menu_Query.functorMenuQuery)(/* #__PURE__ */ (function () {
    var $9 = Data_Newtype.unwrap();
    return function ($10) {
        return (function (v) {
            return v.catalogue;
        })($9($10));
    };
})())(Restaumatic_Menu_Query.askMenu);
var findAvailabilitySchedule = function (id) {
    return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(askMenuCatalogue)(function (catalogue) {
        return Restaumatic_Menu_Query.orError(Restaumatic_Menu_V2_MenuCatalogue.lookupAvailabilitySchedule(catalogue)(id))(function (v) {
            return "Modifier not found: " + Data_Show.show(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId)(id);
        });
    });
};
var findCombo = function (id) {
    return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(askMenuCatalogue)(function (catalogue) {
        return Restaumatic_Menu_Query.orError(Restaumatic_Menu_V2_MenuCatalogue.lookupCombo(catalogue)(id))(function (v) {
            return "Combo not found: " + Data_Show.show(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId)(id);
        });
    });
};
var findCustomParameter = function (id) {
    return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(askMenuCatalogue)(function (catalogue) {
        return Restaumatic_Menu_Query.orError(Restaumatic_Menu_V2_MenuCatalogue.lookupCustomParameter(catalogue)(id))(function (v) {
            return "Custom parameter not found: " + Data_Show.show(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId)(id);
        });
    });
};
var findCustomParameterDefaults = function (ids) {
    return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(askMenuCatalogue)(function (catalogue) {
        return Control_Applicative.pure(Restaumatic_Menu_Query.applicativeMenuQuery)(Restaumatic_Menu_V2_MenuCatalogue.lookupCustomParameterDefaults(catalogue)(ids));
    });
};
var findModifier = function (id) {
    return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(askMenuCatalogue)(function (catalogue) {
        return Restaumatic_Menu_Query.orError(Restaumatic_Menu_V2_MenuCatalogue.lookupModifier(catalogue)(id))(function (v) {
            return "Modifier not found: " + Data_Show.show(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId)(id);
        });
    });
};
var findProduct = function (id) {
    return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(askMenuCatalogue)(function (catalogue) {
        return Restaumatic_Menu_Query.orError(Restaumatic_Menu_V2_MenuCatalogue.lookupProduct(catalogue)(id))(function (v) {
            return "Product not found: " + Data_Show.show(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId)(id);
        });
    });
};
var findProductCategory = function (id) {
    return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(askMenuCatalogue)(function (catalogue) {
        return Restaumatic_Menu_Query.orError(Restaumatic_Menu_V2_MenuCatalogue.lookupProductCategory(catalogue)(id))(function (v) {
            return "Product category not found: " + Data_Show.show(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId)(id);
        });
    });
};
var findSection = function (id) {
    return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(askMenuCatalogue)(function (catalogue) {
        return Restaumatic_Menu_Query.orError(Restaumatic_Menu_V2_MenuCatalogue.lookupSection(catalogue)(id))(function (v) {
            return "Section not found: " + Data_Show.show(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId)(id);
        });
    });
};
var findSectionItem = function (menuSectionId) {
    return function (menuSectionItemId) {
        return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(askMenuCatalogue)(function (catalogue) {
            return Restaumatic_Menu_Query.orError(Restaumatic_Menu_V2_MenuCatalogue.lookupSectionItem(catalogue)(menuSectionId)(menuSectionItemId))(function (v) {
                return "Menu section item not found: " + (Data_Show.show(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId)(menuSectionId) + ("/" + Data_Show.show(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId)(menuSectionItemId)));
            });
        });
    };
};
export {
    askMenuCatalogue,
    findSectionItem,
    findProduct,
    findCombo,
    findProductCategory,
    findSection,
    findCustomParameter,
    findCustomParameterDefaults,
    findModifier,
    findAvailabilitySchedule
};
//# sourceMappingURL=index.js.map
